<template>
  <div class="video-list">
    <div class="filter-wrapper">
      <dropdown class="dropdown" v-model="district" :placeholder="`Выберите федеральный округ`" :options="districtOptions"/>
      <dropdown class="dropdown" v-model="specializationModel" :placeholder="`Выберите специализацию`" :options="specializationOptions"/>
      <div class="clear" v-if="(district || specializationModel)" @click="resetFilter">
        <span class="clear__label">Сбросить фильтр</span>
        <span class="clear__icon">×</span>
      </div>
    </div>
    <div class="list" v-if="(district || specializationModel)">
      <div class="list__title" v-if="districtName">{{ districtName }}</div>
      <div
          class="list__section"
          v-for="section in sections"
          :key="section.code"
      >
        <div class="section__name" :class="`section__name--${section.code}`">
          {{ section.name }}
        </div>
        <div class="section__videos">
          <div
              class="video"
              v-for="video in section.videos"
              :key="video.video"
              @click="$emit('video', video.video)"
          >
            <div class="video__thumb">
              <img
                  :src="
                  `${basePreviewPath}${video.thumb}`
                "
                  :alt="video.title"
                  width="320"
              />
            </div>
            <div class="video__title">
              <span>{{ video.title }}</span>
              <span
                  class="video__info"
                  v-if="video.info"
                  @click.stop="info = video"
              >!</span
              >
            </div>
            <div class="video__info-window" v-if="info === video">
              <span class="info__close" @click.stop="info = null">
                <svg width="32" height="32" viewBox="0 0 32 32">
                  <path
                      fill="#4B7ED5"
                      fill-rule="evenodd"
                      d="M4.55 4.54a15.54 15.54 0 1021.97 0 15.54 15.54 0 00-21.97 0zm19.1 16.15l-2.96 2.95-5.15-5.15-5.16 5.15-2.95-2.96 5.15-5.15-5.15-5.16 2.95-2.95 5.16 5.15 5.15-5.15 2.96 2.95-5.15 5.16z"
                  />
                </svg>
              </span>
              <div class="info__content" v-html="info.info"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "@/components/dropdown";

export default {
  components: {
    Dropdown
  },
  data() {
    return {
      resetFilter: () => {
        this.district = null;
        this.specializationModel = null;
      },
      district: null,
      specializationModel: null,
      info: null,
      basePreviewPath: process.env.NODE_ENV === 'production' ? '/direction/static_content/assets/redkie-bolezni/map/images/videos/' : '/images/previews/',
      diseases: [
        {
          code: "pompe",
          name: "Болезнь Помпе"
        },
        {
          code: "mps",
          name: "МПС I"
        },
        {
          code: "fabri",
          name: "Болезнь Фабри"
        },
        {
          code: "niemann-pika",
          name: "Болезнь Ниманна-Пика"
        }
      ],
      districts: [
        {
          name: "Центральный ФО",
          code: "C"
        },
        {
          name: "Северо-Западный ФО",
          code: "SZ"
        },
        {
          name: "Южный ФО",
          code: "J"
        },
        {
          name: "Северо-Кавказский ФО",
          code: "SK"
        },
        {
          name: "Приволжский ФО",
          code: "P"
        },
        {
          name: "Уральский ФО",
          code: "U"
        },
        {
          name: "Сибирский ФО",
          code: "S"
        },
        {
          name: "Дальневосточный ФО",
          code: "D"
        }
      ]
    };
  },
  props: {
    videos: {
      type: Array,
      default: null
    }
  },
  // watch: {
  //   district
  // },
  computed: {
    districtName() {
      return this.districts.find(district => district.code === this.district)?.name ?? null;
    },
    districtOptions() {
      return this.districts.map(option => {
        option.count = this.videos.filter( video => {
          if ( this.specializationModel !== null )
            return ( video.specialization.indexOf(this.specializationModel) !== -1 ) && ( video.district === option.code );
          else
            return ( video.district === option.code );
        }).length;
        return option;
      });
    },
    specializationOptions() {
      const arSpecializations = [];
      window.mapVideos.forEach(mapElem => {
        mapElem.specialization.forEach(specElem => {
          if (arSpecializations.indexOf(specElem) === -1) {
            arSpecializations.push(specElem);
          }
        });
      });
      const res = arSpecializations.map((item) => {
        const option = {
          name: item,
          code: item,
          count: 0,
        }
        option.count = this.videos.filter(video => {
          if ( this.district !== null )
            return ( video.specialization.indexOf(option.name) !== -1 ) && ( video.district === this.district );
          else
            return ( video.specialization.indexOf(option.name) !== -1 );
        }).length;
        return option;
      });
      return res;
    },
    sections() {
      return this.diseases
          .filter(disease => {
            const videos = this.videos.filter(video => {

              if ( video.disease !== disease.code )
                return false;

              if ( this.district !== null && this.specializationModel !== null )
                return ( video.district === this.district ) && ( video.specialization.indexOf(this.specializationModel) !== -1 );

              if ( this.district !== null )
                return ( video.district === this.district );

              if ( this.specializationModel !== null )
                return ( video.specialization.indexOf(this.specializationModel) !== -1 );

              return false;
                  // video.disease === disease.code && video.district === this.district
            });
            return videos.length;
          })
          .map(disease => {
            const videos = this.videos.filter(video => {

              if ( video.disease !== disease.code )
                return false;

              if ( this.district !== null && this.specializationModel !== null )
                return ( video.district === this.district ) && ( video.specialization.indexOf(this.specializationModel) !== -1 );

              if ( this.district !== null )
                return ( video.district === this.district );

              if ( this.specializationModel !== null )
                return ( video.specialization.indexOf(this.specializationModel) !== -1 );

              return false;
            });
            return {
              ...disease,
              videos
            };
          });
    },
    filterVideos() {

      if (this.district !== null && this.specializationModel !== null) {
        return this.videos.filter(videoItem => videoItem.district === this.district && videoItem.specialization.indexOf(this.specializationModel) !== -1);
      }

      if (this.district !== null) {
        return this.videos.filter(videoItem => videoItem.district === this.district);
      }

      if (this.specializationModel !== null) {
        return this.videos.filter(videoItem => videoItem.district === videoItem.specialization.indexOf(this.specializationModel) !== -1);
      }

      return [];
    },
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  //margin-bottom: 32px;
  position: relative;
  z-index: 5;
  margin-right: 24px;

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 767px) {
    margin-bottom: 24px;
    margin-right: 0;
    &:last-child {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
}

.list {
  margin-bottom: 32px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(#000, 0.16);
  padding: 16px 32px;
  color: #3a3a3a;

  @media (max-width: 767px) {
    box-shadow: none;
    border-radius: 0;
    border-bottom: 1px solid rgba(#7382d0, 0.16);
    padding: 0 16px 16px;
  }

  &__title {
    text-align: center;
    font-size: 28px;
    margin: 16px 0;
    padding: 0 0 16px;
    border-bottom: 1px solid rgba(#7382d0, 0.16);
    min-width: 180px;

    @media (max-width: 767px) {
      margin: 0 0 8px;
      font-size: 18px;
      padding: 0 0 8px;
    }
  }

  &__section {
    border-bottom: 1px solid rgba(#7382d0, 0.16);
    padding: 16px 0 0;

    @media (max-width: 767px) {
      padding: 8px 0 0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.section {
  &__name {
    width: 180px;
    color: #fff;
    box-shadow: 0px 3px 6px rgba(#000, 0.16);
    position: relative;
    margin: 0 0 16px;
    font-family: "Circe";
    font-size: 14px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 12px;

    &:before {
      content: "";
      position: absolute;
      top: 3px;
      left: 12px;
      width: 42px;
      height: 42px;
      background-size: 100% 100%;
    }

    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 32px;
      background: rgba(#fff, 0.2);
    }

    &--pompe {
      background: #b6d3eb;

      &:before {
        //background: url(../assets/pompe.png);
      }
    }

    &--mps {
      background: #bedcae;

      &:before {
        //background: url(../assets/mps.png);
      }
    }

    &--fabri {
      background: #f8c7a4;

      &:before {
        //background: url(../assets/fabri.png);
      }
    }

    &--niemann-pika {
      background: #f78e94;

      &:before {
        //background: url(../assets/fabri.png);
      }
    }
  }

  &__videos {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -16px;
  }
}

.info {
  &__content {
    display: block;
    font-size: 16px;

    ::v-deep {
      p {
        margin: 0;

        + p {
          margin: 1em 0 0;
        }
      }
    }
  }

  &__close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
}

.video {
  width: 33.3333%;
  padding: 0 16px 16px;
  cursor: pointer;
  position: relative;

  &__info-window {
    position: absolute;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.5);
    left: 100%;
    top: -15px;
    width: 100%;
    transition: all 0.3s;
    padding: 45px 20px 20px;
    z-index: 3;

    @media (max-width: 767px) {
      left: 0;
      top: 100%;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
  }

  &:hover &__thumb {
    transform: translate(0, -2px);
  }

  &__thumb {
    box-shadow: 0px 3px 6px rgba(#000, 0.16);
    margin: 0 0 8px;
    position: relative;
    transition: all 0.2s;

    &:after {
      content: "";
      position: absolute;
      background: url(../assets/play.svg);
      background-size: 100% 100%;
      width: 43px;
      height: 30px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    img {
      width: 100%;
      display: block;
      height: auto;
    }
  }

  &__title {
    font-size: 16px;
    line-height: 1.25;
    display: flex;
    align-items: center;
  }

  &__info {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    font-weight: bold;
    width: 32px;
    min-width: 32px;
    margin: 0 0 0 10px;
    height: 32px;
    background: linear-gradient(to bottom, #719fef, #4679d2);
    color: #fff;
    border-radius: 50%;
    box-shadow: 0px 3px 6px rgba(#000, 0.16);
  }
}

.filter-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: 100%;

  background: #eee;
  padding: 10px;
  border-radius: 100px;
  position: relative;

  padding-right: 64px;

  @media (max-width: 767px) {
    background: #f3f3f3;
    border-radius: 32px 32px 0 0;
    padding: 10px 10px 56px;

    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    width: 100%;

    &:after {
      content: "";
      position: absolute;
      right: 0;
      left: 0;
      bottom: 0;
      background: #fff;
      height: 32px;
      border-radius: 32px 32px 0 0;
    }
  }
}

.clear {
  position: absolute;
  right: 10px;
  top: 10px;
  height: 50px;
  width: 50px;
  background: #9c9c9c;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  overflow: hidden;
  text-indent: -99em;
  cursor: pointer;

  .clear__icon {
    display: flex;
  }

  .clear__label {
    display: none;
  }

  span {
    display: none;
  }



  &:hover {
    background: #4679d2;
  }

  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 30px;
    height: 5px;
    background: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &:after {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  @media (max-width: 767px) {
    display: flex;
    position: static;
    inset: auto;

    max-width: 320px;
    width: 100%;
    height: 58px;

    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    color: white;

    text-indent: 0;

    .clear__icon {
      font-size: 40px;
      margin-left: 10px;
      margin-bottom: -6px;
    }
    .clear__label {
      display: inline-block;
    }

    &:before,
    &:after {
      display: none;
    }

  }
}
</style>
